import { Grid } from "@mui/material";
import TypographyLabel from "../../component/Typography";
import advertising from "../../assets/images/advertising.gif";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { AdminSettingsList } from "../../store/AdminSettingsSlice";

export default function Confirm() {
  const ref = useRef(true);
  const dispatch = useDispatch<AppDispatch>();
  const [adminSettings, setAdminSettings] = useState<any>([]);

  useEffect(() => {
    if (ref.current) {
      ref.current = false;
      getAdminSettingsList({ apiAction: "list" });
    }
  }, []);

  //Get admin settings List
  const getAdminSettingsList = (values: any) => {
    dispatch(AdminSettingsList(values))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setAdminSettings(result?.payload?.data?.data);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      });
  };
  return (
    <div>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
        className="changePassword-smallbox "
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={2}
          lg={1}
          className="theme-lite-bg flex"
          style={{
            padding: "0px",
            justifyContent: "center",
          }}
        >
          <div className="center">
            {" "}
            <img src={advertising} width="65px" alt="advertising" />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={11}
          lg={11}
          style={{ padding: "20px 0 20px" }}
        >
          <div className="marquee">
            <p style={{ fontWeight: "bold" }}>
              {adminSettings[adminSettings.length - 1]?.message}
            </p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
